<template>
    <div>
        <h1 class="mb-4 font-active">resizing your ring</h1>
                <p>
                    If you have ordered the wrong ring size, we have got you covered! We offer <b>one complimentary ring resize</b> within the first 12 months of your purchase including free both way shipping within the United States. For shipping outside the United States, shipping charges will be applicable. If your ring is more than a year old or requires a second or further resize, resizing and shipping charges will be applicable. 

                </p>

                <h3>Ring Resizing Terms</h3>
                <p>
                    The ring resizing policy offers complimentary resizes up to 2 sizes above or below the original ring size. In case a resize outside of this range is required, an additional charge may be quoted, or a completely new ring will have to be purchased depending on the design of the ring. Resizing engraved rings may change the look of the engravings. The engraved characters may look different and may not be legible. You can opt to re-engrave the ring after resizing for a $30 fee (up to 20 characters). Please refer to our <router-link :to="localePath('/customer-service/ring-engraving')">ring engraving policy</router-link>  for more information. Excess diamonds or metal left over from resizing will not be returned or refunded for. 

                </p>

                <h3>Rings That Cannot Be Resized</h3>
                <p>
                    Some rings, including eternity rings, full eternity engagement ring settings, and full eternity wedding and matching bands cannot be resized due to the design of the ring. A new ring will have to be purchased in case a resize is required. 

                </p>

                <h3>Shipping Terms for Resized Items</h3>

                <p>
                    All resized items are typically shipped within 7-10 business days from the date of receiving the item.For all international shipments, customs processes and import duties are the customer's responsibility; please check with the local customs office for information. Please refer to our <router-link :to="localePath('/customer-service/shipping-policy')">shipping policy</router-link> for more information.
                </p>

               <h3>How To Send In Your Ring For Resizing </h3>
               <h4>1.  Contact Friendly Diamonds Customer Service Department</h4>
                <ul>
                    <li>
                        If the ring needs to be resized, do not hesitate to contact us! Send us an email at <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with the order number and the word "Ring Resize" in the subject line. Please state the new size for the ring to be resized and provide all the necessary information as per the request.
                    </li>
                    <li>If resizing is possible as per the request, our team will process the order. A shipping label will be created along with the invoice and an email with information on further steps will be sent to the customer.</li>
                    
                </ul>
                <h4>2. Pack Your Order</h4>
                <ul>
                    <li>Ensure that the actual product is securely packed in the original packaging box. 
                    </li>
                    <li>For security reasons, do not write ‘jewelry’, ‘diamonds’, or other related words anywhere on the package.
                    </li>
                    <li>For safety purposes, please double-box your package.</li>
                    <li>Affix the label to the outside of the larger box and drop it off at the nearest courier company location.
                    </li>
                    <li>Friendly Diamonds cannot be held responsible for shipping errors. We recommend that customers only use a staffed storefront to send returned items. Please do not use drop boxes or non-staffed locations.
                    </li>
                    <li>Obtain a shipping receipt to confirm that the item has been shipped. This receipt will act as proof of shipment and insurance.
                    </li>
                    <li>Friendly Diamonds recommends purchasing insurance on the package up to the replacement value.
                    </li>
                </ul>
    </div>
</template>

<script setup>
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }
    p{
        font-size: 14px;
    }

    ul li {
        font-size: 14px;
    }
}
</style>